import Topic from './topic';

export default Topic;